import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = React.HTMLAttributes<HTMLParagraphElement>

function Kicker({ className, children }: Props) {
  return <p className={classNames(style.wrapper, className)}>{children}</p>
}

export default Kicker
